import { Injectable } from '@angular/core';

@Injectable()
export abstract class DataSecurityService {
    public abstract readonly securityLevel: DataSecurityLevel;
}
